import { Box, Chip, Divider, Paper, Stack, Typography } from '@mui/material';
import { type FC, type ReactNode } from 'react';

interface SettingsCardProps {
  id: string;
  icon: ReactNode;
  title: string;
  subtitle?: string;
  action?: ReactNode;
  isDirty?: boolean;
  children: ReactNode;
}

const SettingsCard: FC<SettingsCardProps> = ({ id, icon, title, subtitle, action, isDirty, children }) => (
  <Paper id={id} component={'section'} sx={{ scrollMarginTop: (theme) => theme.spacing(11) }}>
    <Stack direction={'row'} alignItems={'center'} spacing={1.5} sx={{ p: 2.5 }}>
      {icon}
      <Box>
        <Typography variant={'h4'} component={'h2'}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography variant={'body2'} color={'text.secondary'}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>
      <Stack direction={'row'} alignItems={'center'} spacing={1} sx={{ ml: 'auto' }}>
        {isDirty ? <Chip size={'small'} color={'secondary'} variant={'outlined'} label={'Unsaved changes'} /> : null}
        {action}
      </Stack>
    </Stack>
    <Divider />
    <Box sx={{ p: 2.5 }}>{children}</Box>
  </Paper>
);

export default SettingsCard;
